import api from ".";

export const getInventory = (params) => api.get("/products", { params });

export const getArchivedInventory = (params) => api.get("/products/archived", { params });

export const archiveInventory = ({ uuid }) => api.patch(`/products/${uuid}/archive`);

export const unarchiveInventory = ({ uuid }) => api.patch(`/products/${uuid}/unarchive`);

export const editProduct = ({ uuid, ...data }) => api.post(`/products/${uuid}`, data, { headers: { "Content-Type": "multipart/form-data" } });

export const addProduct = (data) => api.post("/products/store", data, { headers: { "Content-Type": "multipart/form-data" } });

export const addBulkProduct = (data) => api.post("/products/add-bulk", data, { headers: { "Content-Type": "multipart/form-data" } });

export const getInventoryLogs = (params) => api.get("/inventories/logs", { params });

export const getIncomingRequest = (params) => api.get("/inventories/incoming-requests", { params });

export const getOutgoingRequest = (params) => api.get("/inventories/outgoing-requests", { params });

export const createRequest = (data) => api.post("/inventories/request-product", data);

export const getRequest = (uuid) => api.get(`/inventories/requests/${uuid}`);

export const approveRequest = ({ uuid, ...data }) => api.post(`/inventories/requests/${uuid}/approve`, data);

export const updateInventory = (data) => api.post("inventories", data);
